export default "__VITE_ASSET__C0MM8Bup__"